export default __webpack_public_path__ + "fonts/ai_2.a1d289599a9571dc10021dd8cc6be442.png";